// client/src/routes/app/documents/ocr.$documentId.tsx — SCR-DOC-003 „Confirmare OCR factură" ·
// DOC-004 phase 2 (04 §8.10's route, §7's own tree: „app/documents/ocr.$documentId.tsx").
//
// A ROUTE OF ITS OWN and not a tab of SCR-DOC-002, because 04 §8.10 gives it one: the confirm
// screen is where a landlord lands from the phone flow of §11.2 P1 („receipt capture … +
// SCR-DOC-003 after OCR") and from the document they just uploaded, and both of those are links
// somebody sends, bookmarks or reloads.
//
// NOTHING IS IN THE URL BUT THE DOCUMENT. There is no `?invoiceId=` and no `?run=1`: the
// reading is a write (`POST /api/v1/documents/{id}/ocr` files a draft invoice), and a URL that
// carried it would make a refresh, a Back and a shared link each file another one — which is
// exactly the duplicate D-1316 records. So the state of this screen is the component's, the URL
// says only which document is open, and reloading it costs nothing (D-1150).
//
// TWO PERMISSIONS, AND THE SECOND ONE IS THE SCREEN'S. `Documents.Read` is what streams the page
// on the left; `Expenses.Write` is what the two buttons on the right do — the extraction writes
// an invoice and the confirmation writes three rows, and `PermissionCatalog` spells the code out
// as „Administrare cheltuieli, facturi, confirmare OCR". The seeded `accountant` holds
// `Documents.Read` and `Expenses.Read` and NEITHER write, so this screen is SCR-SYS-403 for
// them (§9.2.2) — which is the honest answer for a page whose entire content is a write they
// may not make. The link on SCR-DOC-002 is mirrored against the same permission, so they are
// never offered it in the first place.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { invoicesVisible } from '@/config/invoices';
import { OcrConfirm } from '@/features/documents/OcrConfirm';

export const Route = createFileRoute('/app/documents/ocr/$documentId')({
  // Reading an invoice off a document is withdrawn from view with the supplier invoices
  // (D-2780): the address lands on the document itself.
  beforeLoad: ({ params }) => {
    if (!invoicesVisible()) throw redirect({ to: '/app/documents/$documentId', params });
  },
  component: OcrConfirmScreen,
});

function OcrConfirmScreen() {
  const { documentId } = Route.useParams();

  return (
    <RequirePermission permission="Documents.Read">
      <RequirePermission permission="Expenses.Write">
        <OcrConfirm documentId={documentId} />
      </RequirePermission>
    </RequirePermission>
  );
}
